import { extend } from 'vee-validate'
import { email, max, min, regex, required, numeric } from 'vee-validate/dist/rules'
import { i18n } from '@/plugins/vue-i18n'

extend('required', {
  ...required,
  message: i18n.t('validations.required') as string
})

extend('searchLimit', {
  ...required,
  message: i18n.t('validations.search_limit') as string
})

extend('max', {
  ...max,
  message: (_, length) => i18n.t('validations.max', length) as string
})

extend('min', {
  ...min,
  message: (_, length) => i18n.t('validations.min', length) as string
})

extend('minLimit', {
  ...min,
  message: (_, length) => i18n.t('validations.min_limit', length) as string
})

extend('regex', {
  ...regex,
  message: i18n.t('validations.invalid_characters') as string
})

extend('email', {
  ...email,
  message: i18n.t('validations.email') as string
})

extend('numeric', {
  ...numeric,
  message: i18n.t('validations.numeric') as string
})

extend('nohtml', {
  ...regex,
  validate:(code: string) => {
    const regexPattern = new RegExp('^(?:(?!<[^>]*>|&[A-Za-z]+;).)*$');
    return regexPattern.test(code)
  },
  message: i18n.t('validations.invalid_characters') as string
})

extend('requiredAccountNumber', {
  ...required,
  message: i18n.t('validations.bank_account_number_required') as string
})


